import React, { useEffect, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import { Autoplay, Pagination, Navigation } from 'swiper/modules';
import './swiper.scss';
import { Link } from 'react-router-dom';
import axios from 'axios';
import AOS from 'aos';
import 'aos/dist/aos.css';
import BASE_URL from '../../Util/config';

const SimpleSliderEn = () => {
  const slidesPerView = window.innerWidth > 860 ? 4 : 1;
  const [newsData, setNewsData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    AOS.init();
  }, []);

  useEffect(() => {
    const fetchNews = async () => {
      try {
        setLoading(true);
        const response = await axios.get(`${BASE_URL}/api/blog-news/public?type=news&status=published&company=1`);

        console.log('API Response:', response);

        // Filter data yang status-nya true dan memiliki swiper_image
        const filteredData = response.data.data
          .filter((item) => item.status === true && item.swiper_image)
          .map((item) => ({
            id: item.id,
            image: item.swiper_image.startsWith('http') ? item.swiper_image : `${BASE_URL}${item.swiper_image}`,
            title: item.title_en || item.title,
            endpoint: (item.title_en || item.title).replace(/ /g, '-'),
          }));

        console.log('Filtered Data:', filteredData);
        setNewsData(filteredData);
        setError(null);
      } catch (err) {
        console.error('Error fetching news:', err);
        setError('Failed to load data. Please try again.');
      } finally {
        setLoading(false);
      }
    };

    fetchNews();
  }, []);

  if (loading) {
    return (
      <div className="containerSwiper">
        <div className="slideShow">
          <p>Loading data...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="containerSwiper">
        <div className="slideShow">
          <p>{error}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="containerSwiper">
      <div className="slideShow">
        <h3 data-aos="fade-up" data-aos-anchor-placement="top-bottom" data-aos-duration="2500">
          About Remala Abadi
        </h3>
        <p data-aos="fade-up" data-aos-anchor-placement="top-bottom" data-aos-duration="2500">
          Company Activities
        </p>

        {newsData.length > 0 ? (
          <Swiper
            slidesPerView={slidesPerView}
            spaceBetween={10}
            autoplay={{
              delay: 3000,
              disableOnInteraction: false,
            }}
            navigation={true}
            modules={[Autoplay, Pagination, Navigation]}
            data-aos="fade-up"
            data-aos-anchor-placement="top-bottom"
            data-aos-duration="2500"
          >
            {newsData.map((item) => (
              <SwiperSlide key={item.id}>
                <Link to={`/en/news/${item.id}/${item.endpoint}`}>
                  <img
                    src={item.image}
                    alt={item.title}
                    className="imgSwiper"
                    onError={(e) => {
                      console.error('Image failed to load:', item.image);
                      e.target.src = 'https://via.placeholder.com/400x300?text=Image+Not+Found';
                    }}
                  />
                </Link>
              </SwiperSlide>
            ))}
          </Swiper>
        ) : (
          <p>No data to display</p>
        )}
      </div>
    </div>
  );
};

export default SimpleSliderEn;
